<body data-spy="scroll" data-target=".fixed-top">

<app-public-navbar></app-public-navbar>

    <!-- <nav class="navbar navbar-expand-lg fixed-top navbar-light">
        <div class="container"> -->

            <!-- Text Logo - Use this if you don't have a graphic logo -->
            <!-- <a class="navbar-brand logo-text page-scroll" href="index.html">Kora</a> -->

            <!-- Image Logo -->
            <!-- <a class="navbar-brand logo-image" href="">
                <img src="assets/images/xchange.png" alt="alternative"></a>

            <button class="navbar-toggler p-0 border-0" type="button" data-target="#navbarsExampleDefault"
                aria-controls="navbarsExampleDefault" aria-expanded="true" aria-label="toggle navigation"
                data-toggle="collapse">
                <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse1" id="navbarsExampleDefault">
                <ul class="navbar-nav ml-auto">
                    <li class="nav-item">
                        <a class="nav-link page-scroll" routerLink="/">Home <span class="sr-only">(current)</span></a>
                    </li>

                    <li class="nav-item">
                        <a routerLink="/intro" class="nav-link page-scroll" (click)="gotoScroll('intro')">Intro</a>
                    </li>
                       <li class="nav-item">
                        <a routerLink="/howItWorks" class="nav-link page-scroll"
                            (click)="gotoScroll('details')">How it Works</a>
                    </li>
                    <li class="nav-item">
                        <a routerLink="/features" class="nav-link page-scroll"
                            (click)="gotoScroll('features')">Features</a>
                    </li>
                 
                    <li class="nav-item" *ngIf="!user">
                        <a routerLink="/contact-us" class="nav-link page-scroll" href="javascript:void(0)">Contact Us
                        </a>
                    </li>
                    <li class="nav-item" *ngIf="!user">
                        <a routerLink="/faqs" class="nav-link page-scroll" href="javascript:void(0)">FAQ's</a>
                    </li> -->
                    <!-- <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" href="#" id="dropdown01" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false">Drop</a>
                        <div class="dropdown-menu" aria-labelledby="dropdown01">
                            <a class="dropdown-item page-scroll" href="article.html">Article Details</a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item page-scroll" href="terms.html">Terms Conditions</a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item page-scroll" href="privacy.html">Privacy Policy</a>
                        </div>
                    </li>  -->
                    <!-- <li class="nav-item" *ngIf="this.extra">
                        <a routerLink="/account/register-email" class="btn-solid-sm page-scroll" href="">Signup</a>
                        <a routerLink="/account/login" class="btn-solid-sm page-scroll" href="">Login</a>
                    </li>
                    <li class="nav-item" *ngIf="!this.extra">
                        <a routerLink="" class="btn-solid-sm page-scroll" (click)="dashboard()">Go to Content List</a>
                        <a routerLink="/account/login" class="btn-solid-sm page-scroll" (click)="logout()">Logout</a>
                    </li>
                </ul> -->

                <!-- <span class="nav-item" *ngIf="user">
                    <a routerLink="/{{ (user.type == 1) ? 'buyer' : 'seller'}}" class="btn-solid-sm page-scroll" href="">Dashboard</a>
                </span> -->
            <!-- </div> end of navbar-collapse -->
        <!-- </div> end of container -->
    <!-- </nav> -->
    <div class="intro">

        <!-- FULL BACKGROUND IMAGE (cards included) -->
        <div class="top-div">
            <div>
                <img src="assets/newImages/intro-img.png" alt="intro background" class="intro-bg" />
                <div class="hero-content">

                    <h2>
                        <!-- Buy and sell media content via<br />
     fully secured Smart Contracts<br />
      backed by <strong>ESCROW</strong> -->
                        <!-- Why Connekkt Xchange -->
                        The Future of <br /> Media
                        Rights Trading is Here
                    </h2>
                    <p>One Platform. Global Reach. Complete Control.</p>
                    <div class="btn-container">
                    <button class="btn1" routerLink="/contact-us" > Request a demo</button>
                    <!-- <button class="btn2">Join Connekkt Xchange</button> -->
                    </div>
                </div>
            </div>

            <!-- HERO TEXT -->

        </div>
        <div class="bottom-div">
            <!-- LEFT ARROW IMAGE -->
            <!-- <img
    src="assets/newImages/arrow.png"
    alt="flow arrow"
    class="left-arrow"
  /> -->

            <!-- RIGHT SIDE CONTENT -->
            <div class="right-content">

                <div class="info-block">
                    <div class="text">
                        <h3>Unified Content Marketplace </h3>
                        <p>
                            <!-- Host and manage approvals in the backend and act as the master admin managing both “Seller” & “Buyer” while also managing the communication & notifications templates -->
                            Buy, sell, and license content across geographies, formats, and languages from one platform.
                        </p>
                    </div>
                    <img src="assets/newImages/host-manage.png" alt="host manage" />
                </div>

                <div class="info-block">
                    <div class="text">
                        <h3>AI‑Powered Discovery</h3>
                        <p>
                            <!-- Provide L1 support to “Seller” & “Buyer” while also overseeing the analytics of “Seller” & “Buyer” in a combined dashboard -->
                            Intelligent matching connects the right content with the right buyers at the right time.
                        </p>
                    </div>
                    <img src="assets/newImages/intro page AI.jpeg" alt="support" />
                </div>

                <div class="info-block">
                    <div class="text">
                        <h3>Secure Rights Management</h3>
                        <p>
                            Built‑in rights tracking, compliance, and usage transparency.
                            <!-- Handle the “Chat” and “Ticket” interface and also manages the responsibility to release payments to the seller. -->
                        </p>
                        <!-- <button class="cta">
                            <a href="mailto:support@connekktxchange.com">
                                Talk to team </a> </button> -->
                    </div>
                    <img src="assets/newImages/help-desk.png" alt="help desk" />
                </div>
                <div class="info-block">
                    <div class="text">
                        <h3>Actionable Analytics</h3>
                        <p>
                            Real‑time insights into performance, demand, and revenue.
                            <!-- Built‑in rights tracking, compliance, and usage transparency. -->
                            <!-- Handle the “Chat” and “Ticket” interface and also manages the responsibility to release payments to the seller. -->
                        </p>
                        <!-- <button class="cta">
            <a href="mailto:support@connekktxchange.com">
            Talk to team </a> </button> -->
                    </div>
                    <img src="assets/newImages/support.png" alt="support" />
                </div>
                <!-- <div class="last-box">
                    <div class="info-block block-last">
                        <img src="assets/newImages/invoicing.png" alt="">
                        <div class="text-last">
                            <h3>Invoicing</h3>
                            <p>View manage generate invoices</p>
                        </div>
                    </div>
                    <div class="info-block block-last">
                        <img src="assets/newImages/contracting.png" alt="">
                        <div class="text-last">
                            <h3>Contracting</h3>
                            <p>Easy hassle free contracting between parties</p>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
    </div>



    <div class="footer">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="footer-col first">
                        <h6>About Connekkt Xchange</h6>
                        <p class="p-small">Connekkt Xchange is a next‑generation B2B content marketplace that enables
                            publishers, studios, platforms, and distributors to seamlessly discover, license,
                            distribute, and monetize content across global markets.
                        </p>
                    </div> <!-- end of footer-col -->
                    <div class="footer-col second">
                        <h6>Useful Links</h6>
                        <ul class="list-unstyled li-space-lg p-small">
                            <li><a href="/terms&conditions">Terms & Conditions</a><br /> <a
                                    routerLink="/privacy-policy">Privacy
                                    Policy</a> <br><a routerLink="/faqs">FAQs</a> <br><a
                                    routerLink="/privacySettings">Cookie Preferences</a> <br><a
                                    routerLink="/contact-us">Contact Us</a></li>
                            <!-- <li>Useful: <a href="#">Colorpicker</a>, <a href="#">Icon Library</a>, <a
                                    href="#">Illustrations</a></li>
                            <li>Menu: <a class="page-scroll" href="#header">Home</a>, <a class="page-scroll"
                                    href="#intro">Intro</a>, <a class="page-scroll" href="#features">Features</a>, <a
                                    class="page-scroll" href="#details">Details</a></li> -->

                        </ul>
                    </div> <!-- end of footer-col -->
                    <div class="footer-col third">
                        <span class="fa-stack">
                            <a href="#your-link">
                                <img class="footer-img" src="assets/newImages/twitter.png" alt="">

                                <!-- <i class="fas fa-circle fa-stack-2x"></i>
                                <i class="fab fa-facebook-f fa-stack-1x"></i> -->
                            </a>
                        </span>
                        <span class="fa-stack">
                            <a href="#your-link">
                                <img class="footer-img" src="assets/newImages/facebook.png" alt="">

                                <!-- <i class="fas fa-circle fa-stack-2x"></i>
                                <i class="fab fa-twitter fa-stack-1x"></i> -->
                            </a>
                        </span>
                        <span class="fa-stack">
                            <a href="#your-link">
                                <img class="footer-img" src="assets/newImages/instagram.png" alt="">

                                <!-- <i class="fas fa-circle fa-stack-2x"></i>
                                <i class="fab fa-pinterest-p fa-stack-1x"></i> -->
                            </a>
                        </span>
                        <span class="fa-stack">
                            <a href="#your-link">
                                <img class="footer-img" src="assets/newImages/pinterest.png" alt="">

                                <!-- <i class="fas fa-circle fa-stack-2x"></i>
                                <i class="fab fa-instagram fa-stack-1x"></i> -->
                            </a>
                        </span>
                        <p class="p-small">We would love to hear from you <a
                                href="mailto:support@connekktxchange.com"><strong>support@connekktxchange.com</strong></a>
                            <!-- <br /><a href="tel:+4407466 31893"><strong>+44 07466 331893</strong></a> -->
                        </p>

                    </div> <!-- end of footer-col -->
                </div> <!-- end of col -->
            </div> <!-- end of row -->

            <!-- Copyright -->
            <div class="copyright">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <p class="p-small">Copyright © <a href="#your-link">Connekkt Xchange</a></p>
                        </div> <!-- end of col -->
                    </div> <!-- enf of row -->
                </div> <!-- end of container -->
            </div> <!-- end of copyright -->

        </div> <!-- end of container -->
    </div>
</body>